import { render, staticRenderFns } from "./ProgramButton.vue?vue&type=template&id=65160eee&scoped=true&"
import script from "./ProgramButton.vue?vue&type=script&lang=js&"
export * from "./ProgramButton.vue?vue&type=script&lang=js&"
import style0 from "./ProgramButton.vue?vue&type=style&index=0&id=65160eee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65160eee",
  null
  
)

export default component.exports